import { IPageMeta } from "@/services/interfaces";
import { indexModule } from "@/plugins/store-accessors";
import { MenuItem } from "@/store/indexPage/interfaces";

export const newSaleChecker = (meta?: IPageMeta) => {
  if (meta?.menu !== undefined) {
    indexModule.setMenu(meta?.menu as MenuItem);
  }
};
